import {MAT_SNACK_BAR_DATA, MatSnackBarRef} from '@angular/material/snack-bar';
import {Component, inject, OnInit} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

@Component({
    selector: 'app-custom-snackbar',
    templateUrl: './custom-snackbar.component.html',
    styleUrls: ['./custom-snackbar.component.scss'],
})
export class CustomSnackbarComponent implements OnInit {
    snackBarRef = inject(MatSnackBarRef);
    data = inject(MAT_SNACK_BAR_DATA);
    private sanitizer = inject(DomSanitizer);

    sanitizedMessage: SafeHtml | undefined;

    ngOnInit() {
        // Sanitiser le message HTML pour éviter les failles XSS
        this.sanitizedMessage = this.sanitizer.bypassSecurityTrustHtml(this.data.message);
    }

    getIconName(type: string) {
        switch (type) {
            case 'info':
                return 'info';
            case 'warning':
                return 'warning';
            case 'success':
                return 'check_circle';
            case 'error':
                return 'error';
            default:
                return 'info';
        }
    }
}
